export default __webpack_public_path__ + "static/media/errormessage-nobutton@2x.e0bf7cbe.png";